import React from "react";
import { useIntl } from "react-intl";

type SelectGroupProps = {
  id?: string;
  onBlur?: () => void;
  onChange?: () => void;
  optionDisplay?: { [key: string]: { label: { id: string; defaultMessage: string } } };
  value?: string;
  name?: string;
  disabled?: boolean;
  className?: string;
  hasErrors?: boolean;
};

export const SelectGroup = ({
  id,
  optionDisplay,
  className = "",
  disabled = false,
  name,
  onBlur,
  onChange,
  value,
}: SelectGroupProps) => {
  const intl = useIntl();
  return (
    <div className={`SelectGroup ${className}`}>
      <select
        id={id}
        disabled={disabled}
        className="form-control"
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        value={value}>
        {optionDisplay &&
          Object.keys(optionDisplay).map(key => (
            <option value={key} key={key}>
              {intl.formatMessage(optionDisplay[key].label)}
            </option>
          ))}
      </select>
    </div>
  );
};
